var KImageWidgetAnimationType;
(function (KImageWidgetAnimationType) {
    KImageWidgetAnimationType["NoAnimation"] = "NO_ANIMATION";
    KImageWidgetAnimationType["ZoomOnHover"] = "ZOOM_ON_HOVER";
})(KImageWidgetAnimationType || (KImageWidgetAnimationType = {}));

export { KImageWidgetAnimationType };
//# sourceMappingURL=index.props.js.map
